<template lang='pug'>
#context
  v-row(no-gutters style='padding-top: 12px;')
    v-col(cols='5')
      b {{$t('context.variable')}}
    v-col(cols='5')
      b {{$t('context.value')}}
  v-divider
  div(v-for='(variable, i) in variables', :key='i')
    v-row(no-gutters style='margin-bottom: 6px; margin-top: 3px;')
      v-col(cols='5')
        md-field(
          :class='{ "md-invalid": variable.duplicated || variable.isEmpty }'
          style='width: 90%;')
          md-input.contextInput(
            :disabled='isNotCheckedOut',
            :value='variable.name'
            @input='updateVariable(variable, "name", $event)'
            :placeholder="$t('context.addNameForThisVariable')")
          .md-error {{ variable.duplicated ? $t('context.duplicateVariable') : variable.isEmpty ? $t('context.variableIsEmpty') : ''}}

      v-col(cols='5')
        md-field(style='width: 90%;')
          md-input.contextInput(
            :disabled='isNotCheckedOut',
            :value='variable.value'
            @input='updateVariable(variable, "value", $event)'
            :placeholder="$t('context.addValueToThisVariable')")
      v-col(cols='2' style='align-self: center')
        span(
          :class='{ "disable-click": isNotCheckedOut }'
          @click='removeVariable(i)')
          md-icon(style='cursor: pointer; color: blue; padding-left: 24px;')
            | horizontal_rule
    v-divider
  v-row(no-gutters style='margin-bottom: 6px; margin-top: 3px;')
    v-col(cols='5')
      md-field(
        style='width: 90%;',
        :class='{ "md-invalid": newVariable.duplicated }')
        md-input.contextInput(
          v-model='newVariable.name'
          :value='newVariable.name'
          @input='updateVariable(newVariable, "name", newVariable.name)',
          :disabled='isNotCheckedOut'
          :placeholder="$t('context.addNameForThisVariable')")
        .md-error {{ $t('context.variableAlreadyExists') }}
    v-col(cols='5')
      md-field(style='width: 90%;')
        md-input.contextInput(
          v-model='newVariable.value'
          :value='newVariable.value'
          @blur.passive='addVariable()'
          @keyup.enter.stop='addVariable()',
          :disabled='isNotCheckedOut'
          :placeholder="$t('context.addValueToThisVariable')")
    v-col(cols='2' style='align-self: center')
      span(@click='addVariable()')
        md-icon(
          :class='{ "disable-click": isNotCheckedOut || newVariable.duplicated}'
          style='cursor: pointer; color: blue; padding-left: 24px;')
          | add
</template>

<script>
export default {
  model: {
    prop: 'context',
    event: 'update'
  },
  props: {
    context: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    isNotCheckedOut () {
      return !this.$store.getters['snapshots/userCanEdit']
    }
  },
  data: () => ({
    variables: [],
    newVariable: {
      name: '',
      value: ''
    }
  }),
  watch: {
    context: 'initVariables'
  },
  methods: {
    initVariables () {
      this.variables = Object.entries(this.context || {}).map(
        ([name, value]) => ({
          name,
          value
        })
      )
      this.newVariable.duplicated = false
    },
    updateContext () {
      const context = {}
      this.variables.forEach(({ name, value }) => {
        context[name] = this.parseContextValue(value)
      })
      this.$emit('update', context)
    },
    parseContextValue (value) {
      if (value === true || value === false || value === null) return value
      if (value === 'true' || value === 'false') return value === 'true'
      if (value === 'null') return null
      if (!isNaN(value) && isFinite(value)) return Number(value)
      return value
    },
    removeVariable (i) {
      this.variables.splice(i, 1)
      this.updateContext()
    },
    addVariable () {
      if (!this.newVariable.name || this.newVariable.duplicated) return
      this.variables.push(this.newVariable)
      this.newVariable = {
        name: '',
        value: ''
      }
      this.updateContext()
    },
    updateVariable (variable, prop, value) {
      variable[prop] = value
      variable.isEmpty = false
      if (prop === 'name') {
        variable.duplicated = this.variables.some(
          (v) => v.name !== '' && v.name === variable.name && v !== variable
        )
      }
      if (!value) variable.isEmpty = true
      if (!variable.duplicated && !variable.isEmpty) {
        this.updateContext()
      }
    }
  },
  beforeMount () {
    this.initVariables()
  }
}
</script>

<style scoped>
.contextInput {
  background-color: rgb(244, 244, 244) !important;
  padding-left: 4px !important;
}
.disable-click {
  pointer-events: none;
  color: grey !important;
}
</style>
